import React, { useEffect, useMemo, useState } from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import ParentInfo from './Step1/ParentInfo';
import ChildrenInfo from './Step2/ChildrenInfo';
import Preview from './Step3/Preview';
import ParentFormClosed from './ParentFormClosed';
import { useDispatch, useSelector } from 'react-redux';
import { selectConfigByKey } from '../../../custom-slices/configurationSlice';
import { getTotalChildren } from '../parentFormSlice';
import ParentFormClosedCapacity from './ParentFormClosedCapacity';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const ParentForm = () => {
  const dispatch = useDispatch();

  const parentFormState = useSelector((state) => state.parent.parentForm);
  const totalChildren = parentFormState.totalChildren;

  const configsState = useSelector((state) => state.configuration.configs);

  const angelTreeTimeline = selectConfigByKey(
    configsState,
    'angel-tree-timeline'
  );
  const parentFormClosedAfterCapacityReached = selectConfigByKey(
    configsState,
    'parent-form-closed-after-capacity-reached'
  );

  const testingURLArray = useMemo(() => {
    return ['http://localhost:5500', 'https://angeltree-server-test.ufvsus.ca'];
  }, []);

  const openOnProduction = useMemo(() => {
    return Date.now() >=
      new Date(angelTreeTimeline?.registration?.startDate).getTime() &&
      Date.now() <=
        new Date(angelTreeTimeline?.registration?.endDateCheck).getTime()
      ? 0
      : -1;
  }, [angelTreeTimeline]);

  const [step, setStep] = useState(
    testingURLArray.includes(API_URL) ? 0 : openOnProduction
  );

  const nextStep = () => {
    setStep((prev) => prev + 1);
  };

  const prevStep = () => {
    setStep((prev) => prev - 1);
  };

  useEffect(() => {
    const source = axios.CancelToken.source();

    if (openOnProduction && parentFormClosedAfterCapacityReached) {
      dispatch(getTotalChildren())
        .unwrap()
        .then(() => {
          if (totalChildren >= 210) {
            setStep(100); // Set to closed capacity step
          }
        })
        .catch(() => {
          // Handle error if needed
        });

      return () => {
        source.cancel();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, openOnProduction, parentFormClosedAfterCapacityReached]);

  switch (step) {
    case 0:
      return (
        <StyledEngineProvider injectFirst>
          <ParentInfo step={step} nextStep={nextStep} />
        </StyledEngineProvider>
      );

    case 1:
      return (
        <StyledEngineProvider injectFirst>
          <ChildrenInfo step={step} prevStep={prevStep} nextStep={nextStep} />
        </StyledEngineProvider>
      );

    case 2:
      return (
        <StyledEngineProvider injectFirst>
          <Preview
            step={step}
            prevStep={prevStep}
            nextStep={nextStep}
            setStep={setStep}
          />
        </StyledEngineProvider>
      );

    case 100:
      return (
        <StyledEngineProvider injectFirst>
          <ParentFormClosedCapacity angelTreeTimeline={angelTreeTimeline} />
        </StyledEngineProvider>
      );
    default:
      return (
        <StyledEngineProvider injectFirst>
          <ParentFormClosed angelTreeTimeline={angelTreeTimeline} />
        </StyledEngineProvider>
      );
  }
};

export default ParentForm;
